<template>
  <!--状态开关组件--->
  <el-switch
    v-model="switchValue"
    active-text="启用"
    inactive-text="停用"
    :active-value="0"
    :inactive-value="1"
    @change="onChange"
  />
</template>
<script>
import {
  getCurrentInstance,
  defineComponent,
  ref,
  provide,
  reactive,
  onMounted,
  watch,
  toRefs,
  computed,
} from "vue";

import { useStore } from "vuex";
import { useRouter, useRoute } from "vue-router";
export default defineComponent({
  name: "statusSwitch",
  components: {},
  props: {
    /** v-model选中项绑定值*/
    modelValue: {
      type: String,
      default: null,
      required: true,
    },
  },
  setup(props, { emit }) {
    const { proxy } = getCurrentInstance();
    const store = useStore();
    const router = useRouter();
    const route = useRoute();
    const state = reactive({
      switchValue: null,
    });
    onMounted(() => {
      if (typeof props.modelValue === "object") {
        state.switchValue = props.modelValue.value;
      } else {
        state.switchValue = props.modelValue;
      }
    });
    const onChange = () => {
      // emit("update:modelValue", state.switchValue);
    };
    watch(
      () => props.modelValue,
      () => {
        if (typeof props.modelValue === "object") {
          state.switchValue = props.modelValue.value;
        } else {
          state.switchValue = props.modelValue;
        }
      }
    );
    return {
      ...toRefs(state),
      onChange,
    };
  },
});
</script>
<style scoped lang="less">
.process-container {
  width: 100%;
}
</style>
